import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconVerifySelfie = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 72,
	height: 72,
	viewBox: "0 0 72 72",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			opacity: .1,
			width: 72,
			height: 72,
			rx: 6,
			fill: "#0E4EFB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M54 54V55.5C54.8284 55.5 55.5 54.8284 55.5 54H54ZM18 54H16.5C16.5 54.8284 17.1716 55.5 18 55.5V54ZM54 18H55.5C55.5 17.1716 54.8284 16.5 54 16.5V18ZM18 18V16.5C17.1716 16.5 16.5 17.1716 16.5 18H18ZM45.6 55.5H54V52.5H45.6V55.5ZM55.5 54V45.6H52.5V54H55.5ZM26.4 52.5H18V55.5H26.4V52.5ZM19.5 54V45.6H16.5V54H19.5ZM52.5 18V26.4H55.5V18H52.5ZM26.4 16.5H18V19.5H26.4V16.5ZM16.5 18V26.4H19.5V18H16.5ZM45.6 19.5H54V16.5H45.6V19.5Z",
			fill: "#0E4EFB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M45 47C45 42.0294 40.9706 38 36 38C31.0294 38 27 42.0294 27 47",
			stroke: "#0E4EFB",
			strokeWidth: 3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M36 34C38.7614 34 41 31.7614 41 29C41 26.2386 38.7614 24 36 24C33.2386 24 31 26.2386 31 29C31 31.7614 33.2386 34 36 34Z",
			stroke: "#0E4EFB",
			strokeWidth: 3,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgIconVerifySelfie;
